module.exports = __webpack_public_path__ + "img/invite_title_bg.66f85231.png";